// VH-287: the set-up mail's link is `…/set-up#email=…&code=…`. Both come
// after `#`, which a browser never sends to a server.

/** { email, code } from the link's `#` part; empty strings when absent. */
export function readSetupLink(hash) {
  const params = new URLSearchParams((hash || '').replace(/^#/, ''))
  return { email: params.get('email') || '', code: params.get('code') || '' }
}
